import React from 'react';
import styled from 'styled-components';
import PText from '../components/PText';
import AboutImg from '../assets/images/about-page-img.png';
import AboutInfoItem from '../components/AboutInfoItem';
import ContactBanner from '../components/ContactBanner';

const AboutStyles = styled.div`
  padding: 20rem 0 10rem 0;
  .top-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
  }
  .left {
    flex: 3;
  }
  .right {
    flex: 2;
  }
  .about__subheading {
    font-size: 2.2rem;
    margin-bottom: 2rem;
    span {
      background-color: var(--deep-dark);
      padding: 0.5rem;
      border-radius: 8px;
    }
  }
  .about__heading {
    font-size: 3.6rem;
    margin-bottom: 3rem;
  }
  .about__info {
    margin-bottom: 4rem;
    .para {
      max-width: 100%;
    }
  }
  .right {
    img {
      border: 2px solid var(--gray-1);
    }
  }
  .about__info__items {
    margin-top: 15rem;
  }
  .about__info__item {
    margin-bottom: 10rem;
  }
  .about__info__heading {
    font-size: 3.6rem;
    text-transform: uppercase;
  }
  @media only screen and (max-width: 768px) {
    padding: 10rem 0;
    .top-section {
      flex-direction: column;
      gap: 5rem;
    }
    .about__subheading {
      font-size: 1.8rem;
    }
    .about__heading {
      font-size: 2.8rem;
    }
    .about__info__heading {
      font-size: 3rem;
    }
  }
`;

export default function About() {
  return (
    <AboutStyles>
      <div className="container">
        <div className="top-section">
          <div className="left">
            <p className="about__subheading">
              Hi, I am <span>Naveen Kumar</span>
            </p>
            <h2 className="about__heading">A backend web develooper</h2>
            <div className="about__info">
              <PText>
                I am from Kurnool, India. A place of beauty and nature, with
                very beautiful mindset people.
                <br />
                <br />
                In my childhood I am very passionate 'bout learning tech skills.
                I always try to learn new things daily solving problems. I
                started coding since I was in PUC 2. Coding is an challenging. I
                love it. I find it really interesting and I enjoyed the process
                a lot.
                <br />
                <br />
                My vision is to make the world a better place. Now almost
                everythin is becoming better than ever. It is time for us to
                create more good stuff that helps the world to become better
                place.
                <br />
                <br />
                When you came to Kurnool, don't forget to visit Kondareddy Fort.
              </PText>
              {/* <Button btnText="Download CV" btnLink="#" /> */}
            </div>
          </div>
          <div className="right">
            <img src={AboutImg} alt="about img" />
          </div>
        </div>
        <div className="about__info__items">
          <div className="about__info__item">
            <h1 className="about__info__heading">Education</h1>
            <AboutInfoItem
              title="School"
              items={['Zill Parishad High School, Peddakadabur']}
            />
            <AboutInfoItem
              title="College"
              items={[
                'Rajiv Gandhi University of Knowledge Technologies, RK Valley',
              ]}
            />
            <AboutInfoItem
              title="University"
              items={[
                'Rajiv Gandhi University of Knowledge Technologies, RK Valley',
              ]}
            />
          </div>
          <div className="about__info__item">
            <h1 className="about__info__heading">My Skills</h1>
            <AboutInfoItem
              title="FrontEnd"
              items={['HTML', 'CSS', 'JavaScript', 'React']}
            />
            <AboutInfoItem title="Backend" items={['Python', 'Django']} />
            <AboutInfoItem
              title="Learning"
              items={['Machine Learning', 'Data Science', 'GO - Fundamentals']}
            />
            <AboutInfoItem
              title="Other"
              items={['Linux', 'Shell', 'GIT', 'JIRA', 'Heroku']}
            />
          </div>
          <div className="about__info__item">
            <h1 className="about__info__heading">Experiences</h1>
            <AboutInfoItem
              title="2021 - Present"
              items={['Software Developer Engineer 1 at CAW Studios']}
            />
            <AboutInfoItem
              title="2019 - 2021"
              items={['Software Developer Intern at iB Hubs']}
            />
          </div>
        </div>
      </div>
      <ContactBanner />
    </AboutStyles>
  );
}
